module.exports = __webpack_public_path__ + "media/images/circle-close-icon-1d0727f8a2a8c7731b764ee287bd3ddf.png";